// extracted by mini-css-extract-plugin
export var tosLink = "_53-0";